<div class="container coursesList fadeIn my-5">
  <div class="row">
    <div class="col-12">
      <h2
        class="titleTextFont font-weight-normal text-center"
        style="font-size: 2.4rem"
        [innerHTML]="title"
      >
      </h2>
    </div>
    <div class="col-12">
      <h2
        class="font-weight-normal fadeIn text-center mb-3 subtitle-block"
        style="font-size: 1.5rem"
        [innerHtml]="subtitle"
      ></h2>
    </div>
  </div>
  <div class="row">
    <div
      class="courseItem col-md-4 col-12 animate__animated animate__fadeIn"
      *ngFor="let course of courses"
      [routerLink]="['/courses/profile', course.id]"
    >
      <div class="itemImage hover-shadow">
        <picture>
          <img
            sizes="(max-width: 768px) 100vw, 33vw"
            [src]="course.image"
          />
        </picture>
      </div>
      <div class="itemDetails">
        <p
          class="itemTitle hover-text-shadow"
          [innerHTML]="course.name"
        ></p>
        <div class="row">
          <div>
            <div *ngIf="course.count == 1" class="col">
              <p class="count">
                ({{ course.count }} lección )
              </p>
            </div>
            <div *ngIf="course.count > 1" class="col">
              <p class="count">
                ({{ course.count }} lecciones )
              </p>
            </div>
          </div>

          <div class="col" *ngIf="course.price; else free">
            <div *ngIf="course.discounted" class="col-12 px-0">
              <span style="font-size: 16px" class="text-muted mr-2">
                <del>{{ course.price }} €</del>
              </span>
            </div>
            <div class="d-flex align-items-center">
              <div class="col-auto px-0">
                <p class="text-left text-info font-weight-bold textFont mb-0">
                  {{ course.finalPrice }} €
                </p>
              </div>
              <div class="col-auto px-0">
                <span
                  *ngIf="course.discounted"
                  class="badge bg-extra text-light mx-2 px-3"
                  >Descuento {{ course.discountRate }}% OFF</span
                >
              </div>
            </div>
          </div>
          <ng-template #free>
            <div class="col">
              <p
                class="text-left font-weight-bold textFont text-info"
              >
                Gratis
              </p>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="row align-center">
    <a
      href="#"
      class="btn btn-info btn-flex m-2 col-auto"
    >
      Ver todos los cursos
      <i class="fa fa-arrow-right mx-2"></i>
    </a>
  </div>
</div>
